import { Button, csx, IconArrowLeft } from '@vtex/admin-ui'
import React from 'react'
import { graphql } from 'babel-plugin-relay/macro'
import { useSuspenseFragment } from 'react-relay-offline'
import { useHistory, useLocation } from 'react-router'

import { DrawerBody, DrawerTitle } from '../../../../ui/components'
import type { PaymentMethodInfoStep_PaymentOptionConnection$key } from './__generated__/PaymentMethodInfoStep_PaymentOptionConnection.graphql'
import { PaymentMethodInfoContent } from './PaymentMethodInfoContent'

const paymentOptionConnectionFragment = graphql`
  fragment PaymentMethodInfoStep_PaymentOptionConnection on PaymentOptionConnection {
    edges {
      node {
        paymentMethod {
          id
          name
        }
        ...PaymentMethodInfoContent_PaymentOption
      }
    }
  }
`

export type PaymentMethodInfoStepProps = {
  paymentOptionConnectionRef: PaymentMethodInfoStep_PaymentOptionConnection$key
}

export const PaymentMethodInfoStep = ({
  paymentOptionConnectionRef,
}: PaymentMethodInfoStepProps) => {
  const history = useHistory()
  const { hash } = useLocation()

  const paymentOptionConnection = useSuspenseFragment(
    paymentOptionConnectionFragment,
    paymentOptionConnectionRef
  )

  const selectedPaymentMethodId = hash.split('/')[2]

  const paymentOption = paymentOptionConnection.edges.find(
    (currentPaymentOption) =>
      currentPaymentOption.node.paymentMethod.id === selectedPaymentMethodId
  )

  const handleBackButtonClick = () => {
    history.goBack()
  }

  if (!paymentOption) return null

  return (
    <>
      <DrawerTitle
        className={csx({
          display: 'flex',
          alignItems: 'center',
        })}
      >
        <Button
          variant="tertiary"
          icon={<IconArrowLeft size="small" color="black" />}
          className={csx({ marginRight: '$space-2' })}
          onClick={handleBackButtonClick}
        />
        {paymentOption.node.paymentMethod.name}
      </DrawerTitle>
      <DrawerBody>
        <PaymentMethodInfoContent paymentOptionRef={paymentOption.node} />
      </DrawerBody>
    </>
  )
}
